export const environment = {
  rememberMeKey: 'MW_RM_K_D',
  base_url: 'https://mindbaseuser-devapi.appgrowthcompany.com/',
  core_url: '',
  image_url: 'https://mindbaseuser-devapi.appgrowthcompany.com/media/uploadFile',
  storageKey: 'MW_ST_K_D',
  googleKey: 'AIzaSyCES0pCZNW9kCYzWiq4g0oDvSjPQUAyLVY' // Google key of apptunix for localhost and staging
};
    